<template>
  <div class="login-area">
    <form class="col-10 col-md-4 form-login" @submit.prevent="register">
      <div class="card">
        <div class="card-header text-center">
          <h1 class="mb-0">Novo usuário</h1>
        </div>
        <div class="card-body">
          <div class="form-group">
            <input required type="email" class="form-control" placeholder="E-mail" v-model="email">
          </div>
          <div class="form-group">
            <input required type="password" class="form-control" placeholder="Password" v-model="password">
          </div>
          <button class="btn btn-primary btn-block">
            <template v-if="loading" :disabled="loading">
              Entrando <i class="fa fa-spinner fa-spin"></i>
            </template>
            <template v-else>
              Cadastrar <i class="fa fa-sign-in-alt"></i>
            </template>
          </button>
        </div>
        <div class="card-footer text-center">
          <router-link to='/login'>Voltar para tela de login</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {
      loading: false,
      email: '',
      password: ''
    }
  },
  methods: {
    async register () {
      try {
        this.loading = true

        const { email, password } = this
        const res = await this.$firebase.auth().createUserWithEmailAndPassword(email, password)

        window.uid = res.user.uid

        this.$router.push({ name: 'today' })
      } catch (error) {
        let message = `${error.code} - ${error.message}`

        if (error.code === 'auth/email-already-in-use') {
          message = 'E-mail já está em uso'
        }

        this.$root.$emit('Notification::show', { message })
      } finally {
        this.loading = false
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (window.uid) {
        vm.$router.push({ name: 'today' })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.login-area {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-login {
  h1 {
    font-size: 1.5rem;
  }
  .card {
    color: var(--darker);
  }
}
.card-footer {
  font-size: 0.9rem;
}
</style>
